import React, { useState } from 'react';
import { string } from 'prop-types';
import Popover from 'ps-components/Popover/Popover';
import classnames from 'classnames';

SmartInfo.propTypes = {
  className: string
};

const searchOperatorDescriptions = [
  {
    title: 'What is <module>?',
    description: 'Find documentation for MarketPay features',
    example: 'e.g. "What is Market Pricing?" or "How does Survey Participation work?"'
  },
  {
    title: 'Navigate to <module>',
    description: 'Navigate to a module in MarketPay',
    example: 'e.g. "Go to Report Library" or "Open RL"'
  },
  {
    title: 'Contact Support',
    description: 'Create a new support ticket',
    example: 'e.g. "help" or "create a ticket"'
  },
  {
    title: 'Create a new job',
    description: 'Create a new Job pricing through the Ad Hoc Pricing feature',
    example: 'e.g. "Create a new job"'
  },
  {
    title: 'Recent Jobs',
    description: 'Display recently modified Job pricings',
    example: 'e.g. "Show my recent jobs" or "Bring up my last jobs"'
  },
  {
    title: 'Find Jobs with Job Title: <title>',
    description: 'Search for Job pricings with a given job title',
    example: 'e.g. "Search for jobs with title accoutant"'
  },
  {
    title: 'Find Jobs with Job Code: <code>',
    description: 'Search for Job pricings with a given Job Code',
    example: 'e.g. "Open jobs with code 123"'
  },
  {
    title: 'Find Jobs with Currency: <currency>',
    description: 'Search for Job pricings with a given currency',
    example: 'e.g. "Find jobs with currency USD" or "Search jobs currency AUD"'
  },
  {
    title: 'Find Jobs with Status: <status>',
    description: 'Search for Jobs that are priced, slotted, or neither',
    example: 'e.g. "Show me all priced jobs" or "Search jobs slotted"'
  }
];

export default function SmartInfo(props) {
  const { className } = props;
  const [searchInputShow, setSearchInputShow] = useState(false);

  function toggleSearchInputShow(event) {
    event?.stopPropagation();
    setSearchInputShow(!searchInputShow);
  }

  return (
    <span className={classnames('icon-reverse icon-circle smart-search__search-info', className)}>
      <i onClick={toggleSearchInputShow} title="Quick Nav Info" className="icon-info smart-search__search-info-icon" />
      <span className="smart-search__search-info-popover" id="smart-search__search-info-popover">
        {searchInputShow && (
          <Popover
            popoverClassnames="smart-search__search-info-popover-inner"
            relativeElement={document.querySelector('span#smart-search__search-info-popover')}
            display={true}
            arrowAlign="center"
            togglePopover={toggleSearchInputShow}
          >
            <>
              <div className="smart-search__info-title">
                <b>Quick Nav</b> is a set of shortcuts for getting around MarketPay. Below are available shortcuts:
              </div>
              {searchOperatorDescriptions.map((operator, idx) => (
                <div className="search-operator__popover" key={'operator' + idx}>
                  <div className="search-operator__title">{operator.title}</div>
                  <div className="search-operator__description">{operator.description}</div>
                  <div className="search-operator__example">{operator.example}</div>
                </div>
              ))}
            </>
          </Popover>
        )}
      </span>
    </span>
  );
}
